import React, { useState } from 'react'

import { Grid, Header, Button } from 'semantic-ui-react'

import ExternalLink from '../../../components/common/ExternalLink'

const CollaborateTab = () => {
  const [showForm, setShowForm] = useState(false)

  return (
    <div style={{ textAlign: 'center' }}>
      <Header as="h2" style={{ fontWeight: 'bold' }}>
        By using our API
      </Header>
      
      <Grid columns={1} verticalAlign="middle" stackable>
        <Grid.Column>
          <Header as="h4">
            <Header.Subheader>
              Your want full control of your user experience, or want to integrate with your existing tech stack? Request access to our API documentation and build your own video submission workflows.
            </Header.Subheader>
          </Header>
        </Grid.Column>
        
        <Grid.Column>
          <Button compact primary onClick={() => setShowForm(!showForm)}>
            Request Access
          </Button>
        </Grid.Column>

        <Grid.Column style={{ display: showForm ? 'block' : 'none' }}>
          <iframe title="Vloggi API enquiry" src="https://vloggi.activehosted.com/f/52" width="100%" height="400" style={{ border: '1px solid #eeeeee', borderRadius: '10px' }}></iframe>
        </Grid.Column>

        <Grid.Column>
          <ExternalLink url="https://vloggi.com/docs/accessing-the-public-vloggi-api-for-advanced-users/">Read more</ExternalLink>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default CollaborateTab
